module.exports = __webpack_public_path__ + "img/hzkh4.2a4dfabd.jpg";